import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {PartnerWalletDownloadStatementModel} from '../../../models/partner-wallet-transfer-funds-model';


@Component({
  selector: 'app-download-statement-dialog',
  templateUrl: './download-statement-dialog.component.html',
  styleUrls: ['./download-statement-dialog.component.css']
})
export class DownloadStatementDialogComponent implements OnInit {
  public title = 'Download statement';
  public text = 'Please select FROM- and TO-date and format';


  public walletId: number|null;
  public from: Date;
  public to: Date;
  public format: string;

  constructor(
    public dialogRef: MatDialogRef<DownloadStatementDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PartnerWalletDownloadStatementModel
  ) { }

  ngOnInit() {

    if (this.data != null) {
      this.walletId = this.data.walletId;
      this.from = this.data.from;
      this.to = this.data.to;
      this.format = this.data.format;
    }
  }

  onYesClick(): void {

    const model = new PartnerWalletDownloadStatementModel();
    model.from = this.from;
    model.to = this.to;
    model.walletId = this.walletId;
    model.format = this.format;

    this.dialogRef.close(model);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }


}
